import { Helmet } from "react-helmet"
import {
    Box,
    Button,
    Divider,
    FormControlLabel,
    Grid,
    InputAdornment,
    Icon,
    Paper,
    Popover,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    tooltipClasses,
    Typography
} from "@mui/material"
import React, { useEffect, useMemo, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { makeStyles, styled } from "@mui/styles"
import { useTranslation } from "react-i18next"
import { find, isArray } from 'lodash'

import Search from "@mui/icons-material/Search"
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg"
import { ReactComponent as FilterIcon } from "../../../../icons/filter.svg"

import CustomCheckbox from "../../../../components/CustomCheckbox"

import {
    getCompetencyGapDashboard,
    getCompetencyRatingDashboard
} from "../../../../actions/managerDashboard"

import * as Util from "../../../../services/global.service"
import cssVariables from "../../../../theme/cssVariables"

const NoData = () => {
    const { t } = useTranslation()
    return (<Box sx={{ py: "50px", "text-align": "center" }}>
        <Nodata />
        <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
            {t('label.noDataFilter')}
        </Typography>
        <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
            {t('label.tryChangingFilter')}
        </Typography>
    </Box>)
}


const RATING_COLOR = [
    { "condition": { "min": 0, "max": 0.99 }, "color": { "background": "#D34B4E" } }
    , { "condition": { "min": 1, "max": 1.99 }, "color": { "background": "#FB7454" } }
    , { "condition": { "min": 2, "max": 2.99 }, "color": { "background": "#FDB379" } }
    , { "condition": { "min": 3, "max": 3.99 }, "color": { "background": "#D7DF81" } }
    , { "condition": { "min": 4, "max": 4.99 }, "color": { "background": "#D7DF81" } }
    , { "condition": { "min": 5 }, "color": { "background": "#77C47C" } }
]


const CompetencyManagerDashboard = (props) => {
    const { t, i18n } = useTranslation()
    const managerDashboardState = useSelector((state) => state.ManagerDashboard)
    const site = localStorage.getItem("site")
    const dispatch = useDispatch()
    const useStyles = makeStyles({
        flexPaper: {
            flex: 1,
            minWidth: 350,
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)!important",
            borderRadius: "0px 10px 10px 10px!important",
            padding: "20px"
        },
        paperRoot: {
            display: "flex",
            width: "100%",
            flexWrap: "wrap",
        },
        toggleBtnRoot: {
            backgroundColor: "#FFF"
        },
        toggleBtnSelected: {
            backgroundColor: `${cssVariables.color.primary}!important`,
            border: "1px solid #DADADA!important"
        },
        checkGreenSvg: {
            background: "#FFF",
            borderRadius: "50%"
        }
    })
    const classes = useStyles()

    const SyncScroll = (elem) => {
        let nameDiv = document.getElementById("scrollable-name")
        let dataDiv = document.getElementById("scrollable-data")
        if (elem === "scrollable-data") {
            nameDiv.scrollTop = dataDiv.scrollTop
        } else if (elem === "scrollable-name") {
            dataDiv.scrollTop = nameDiv.scrollTop
        }
    }


    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }))

    const [filtersQuery, setFiltersQuery] = React.useState({
        query: "",
        reqData: {
            organization_id: [],
            cycle_id: ""
        }
    })
    const [currentCycle, setCurrentCycle] = React.useState({})
    const [search, setSearch] = React.useState("")
    const [tableType, setTableType] = React.useState("gap")
    const [list, setList] = React.useState([])
    const [masterList, setMasterList] = React.useState([])
    const [filteredList, setFilteredList] = React.useState([])
    const [offsetIndex, setOffsetIndex] = React.useState(0)
    const [excludeFiltersIndex, setExcludeFiltersIndex] = React.useState([])
    const [totalCompetency, setTotalCompetency] = React.useState(0)
    const [filterAnchor, setFilterAnchor] = React.useState(null)
    const [filtersCheckbox, setFiltersCheckbox] = React.useState([])
    const [filtersCheckboxList, setFiltersCheckboxList] = React.useState([])
    const [checkboxFiltersStatus, setCheckboxFiltersStatus] = React.useState("all")
    const openFilters = Boolean(filterAnchor)
    const idFilters = openFilters ? 'filters-popover' : undefined
    const [customizeData, setCustomizeData] = useState({})
    const [ratingColorList, setRatingColorList] = useState(RATING_COLOR)

    const handleClickFilters = (event) => {
        setFilterAnchor(event.currentTarget)
    }
    const handleCloseFilters = () => {
        setFilterAnchor(null)
    }

    const handleFiltersCheckboxs = (data) => {
        let tmpFiltersCheckbox = JSON.parse(JSON.stringify(filtersCheckbox))
        let tmpFiltersCheckboxList = [...filtersCheckboxList]
        if (data === "all") {
            if (checkboxFiltersStatus === "indeterminate" || checkboxFiltersStatus === "none") {
                let selectAllFilters = tmpFiltersCheckboxList.map(filter => filter)
                tmpFiltersCheckbox = selectAllFilters
            } else if (checkboxFiltersStatus === "all") {
                tmpFiltersCheckbox = []
            }
        } else {
            let isExisted = tmpFiltersCheckbox.find(item => item === data)
            if (isExisted) {
                tmpFiltersCheckbox = tmpFiltersCheckbox.filter(item => item !== data)
            } else if (!isExisted) {
                tmpFiltersCheckbox.push(data)
            }
        }
        setFiltersCheckbox(tmpFiltersCheckbox)
    }

    const handleFiltersCheckbox = (val) => {
        let tmpCheckbox = []
        if (val === "all") {
            if (filtersCheckbox.length >= 0 && filtersCheckbox.length < filtersCheckboxList.length) {
                filtersCheckboxList.forEach(status => {
                    tmpCheckbox.push(status)
                })
            } else {
                tmpCheckbox = []
            }
        } else {
            if (filtersCheckbox.includes(val)) {
                tmpCheckbox = [...filtersCheckbox].filter(status => status !== val)
            } else {
                tmpCheckbox = [...filtersCheckbox, val]
            }
        }
        setFiltersCheckbox(tmpCheckbox)
    }

    const loadData = () => {
        // Gap
        if (tableType === "gap") {
            dispatch(getCompetencyGapDashboard(filtersQuery)).then((resp) => {
                let competencyGap = resp?.data?.competency_gap
                let sumTotalGap = resp?.data?.sum_total_gap
                let totalEmployee = resp?.data?.total_employee

                setCustomizeData(resp?.custom?.dashboard_competency?.configuration ?? {})

                let tmpCompetencyLength = []
                for (let i = 0; i < competencyGap?.value?.length; i++) {
                    tmpCompetencyLength.push(0)
                }
                setTotalCompetency(tmpCompetencyLength)
                let resultGapList = {}
                if (competencyGap) {
                    let tmpOffsetIndex = 0
                    // set label
                    resultGapList = competencyGap.label.map(label => {
                        if (!label.fullname) {
                            tmpOffsetIndex++
                        }
                        return { label }
                    })
                    setOffsetIndex(tmpOffsetIndex - 1)
                    // set value
                    let findCompetency = resultGapList.findIndex(row => row?.label?.name?.toLowerCase() === "competency")
                    let findTotalEmp = resultGapList.findIndex(row => row?.label?.name?.toLowerCase() === "total emp.")
                    let findEmpWithGap = resultGapList.findIndex(row => row?.label?.name?.toLowerCase() === "emp. with gap")
                    let findTotalGap = resultGapList.findIndex(row => row?.label?.name?.toLowerCase() === "toatal gap" || row?.label?.name?.toLowerCase() === "total gap")
                    let findAvgGap = resultGapList.findIndex(row => row?.label?.name?.toLowerCase() === "avg. gap")
                    let valueList = {
                        competency: [],
                        totalEmp: [],
                        empWithGap: [],
                        totalGap: [],
                        avgGap: []
                    }
                    let empValueList = {}

                    let filtersList = []
                    competencyGap.value.forEach(value => {
                        // before emp value
                        valueList.competency.push(value?.competency)
                        valueList.totalEmp.push(value?.total_employee)
                        valueList.empWithGap.push(value?.emp_with_gap)
                        valueList.totalGap.push(value?.total_gap)
                        valueList.avgGap.push(value?.avg_gap)
                        // init emp key
                        value.employee_value.forEach((_, empIndex) => {
                            empValueList[tmpOffsetIndex + empIndex] = []
                        })

                        // set filters
                        if (value?.competency?.competency_type?.name) {
                            if (!filtersList.includes(value.competency.competency_type.name)) {
                                filtersList.push(value.competency.competency_type.name)
                            }
                        }
                        setFiltersCheckboxList(filtersList)
                        setFiltersCheckbox(filtersList)

                    })
                    // set before emp value
                    if (findCompetency > -1) resultGapList[findCompetency].value = valueList.competency
                    if (findTotalEmp > -1) resultGapList[findTotalEmp].value = valueList.totalEmp
                    if (findEmpWithGap > -1) resultGapList[findEmpWithGap].value = valueList.empWithGap
                    if (findTotalGap > -1) resultGapList[findTotalGap].value = valueList.totalGap
                    if (findAvgGap > -1) resultGapList[findAvgGap].value = valueList.avgGap

                    // set emp value
                    competencyGap.value.forEach(value => {
                        value.employee_value.forEach((empVal, empIndex) => {
                            empValueList[tmpOffsetIndex + empIndex].push(empVal)
                        })
                    })
                    for (const [key, value] of Object.entries(empValueList)) {
                        if (resultGapList?.[key] ?? false) {
                            resultGapList[key].value = value
                        }
                    }
                    // set total gap for each emp
                    let tmpTotalGapList = {}
                    sumTotalGap.forEach((_, gapIndex) => {
                        tmpTotalGapList[tmpOffsetIndex + gapIndex] = []
                    })
                    sumTotalGap.forEach((totalGap, gapIndex) => {
                        tmpTotalGapList[tmpOffsetIndex + gapIndex].push(totalGap?.value)
                    })
                    for (const [key, value] of Object.entries(tmpTotalGapList)) {
                        resultGapList[key].sumTotalGap = value?.[0]
                    }
                }
                setList(resultGapList)
                setMasterList(resultGapList)
                dispatch({
                    type: "SET_TOTAL_EMPLOYEE_DASHBOARD_MANAGER",
                    payload: totalEmployee ?? 0
                })
            })
        } else {
            // Rating
            dispatch(getCompetencyRatingDashboard(filtersQuery)).then((resp) => {
                let competencyRating = resp?.data?.competency_rating
                let totalEmployee = resp?.data?.total_employee
                let tmpCompetencyLength = []
                for (let i = 0; i < competencyRating?.value?.length; i++) {
                    tmpCompetencyLength.push(0)
                }

                setCustomizeData(resp?.custom?.dashboard_competency?.configuration ?? {})

                setTotalCompetency(tmpCompetencyLength)
                let resultRatingList = {}
                if (competencyRating) {
                    // set label
                    resultRatingList = competencyRating.label.map(label => {
                        return { label }
                    })
                    // set value
                    let findCompetency = resultRatingList.findIndex(row => row?.label?.name?.toLowerCase() === "competency")
                    let findTotalEmp = resultRatingList.findIndex(row => row?.label?.name?.toLowerCase() === "total emp.")
                    let findAvgRating = resultRatingList.findIndex(row => row?.label?.name?.toLowerCase() === "avg. rating")
                    let valueList = {
                        competency: [],
                        totalEmp: [],
                        avgRating: []
                    }
                    let empValueList = {}
                    let tmpOffsetIndex = 2
                    setOffsetIndex(tmpOffsetIndex)

                    let filtersList = []
                    competencyRating.value.forEach(value => {
                        // before emp value
                        valueList.competency.push(value?.competency)
                        valueList.totalEmp.push(value?.total_employee)
                        valueList.avgRating.push(value?.avg_rating)
                        // init emp key
                        value.employee_value.forEach((_, empIndex) => {
                            empValueList[tmpOffsetIndex + 1 + empIndex] = []
                        })

                        // set filters
                        if (value?.competency?.competency_type?.name) {
                            if (!filtersList.includes(value.competency.competency_type.name)) {
                                filtersList.push(value.competency.competency_type.name)
                            }
                        }
                        setFiltersCheckboxList(filtersList)
                        setFiltersCheckbox(filtersList)

                    })
                    // set before emp value
                    if (findCompetency > -1) resultRatingList[findCompetency].value = valueList.competency
                    if (findTotalEmp > -1) resultRatingList[findTotalEmp].value = valueList.totalEmp
                    if (findAvgRating > -1) resultRatingList[findAvgRating].value = valueList.avgRating

                    // set emp value
                    competencyRating.value.forEach(value => {
                        value.employee_value.forEach((empVal, empIndex) => {
                            empValueList[tmpOffsetIndex + 1 + empIndex].push(empVal)
                        })
                    })
                    for (const [key, value] of Object.entries(empValueList)) {
                        if (resultRatingList?.[key]) {
                            resultRatingList[key].value = value
                        }
                    }
                }
                setList(resultRatingList)
                setMasterList(resultRatingList)
                dispatch({
                    type: "SET_TOTAL_EMPLOYEE_DASHBOARD_MANAGER",
                    payload: totalEmployee ?? 0
                })
            })
        }
    }

    const handleChangeTableType = (_, val) => {
        if (val !== null) {
            setTableType(val)
        }
    }

    const handleSearch = (e) => {
        setSearch(e.target.value)
    }

    const sortData = (key, direction) => {
        let result = [...filteredList]
        if (tableType === "gap") {
            result = result.sort((a, b) => {
                if (direction) {
                    return String(a[key]).localeCompare(String(b[key]))
                } else {
                    return String(b[key]).localeCompare(String(a[key]))
                }
            })
        } else {
            result = result.sort((b, a) => {
                if (direction) {
                    if (key !== "classification" && key !== "performance" && key !== "potential") {
                        return String(a[key]).localeCompare(String(b[key]))
                    } else {
                        return String(a[key].label).localeCompare(String(b[key].label))
                    }
                } else {
                    if (key !== "classification" && key !== "performance" && key !== "potential") {
                        return String(b[key]).localeCompare(String(a[key]))
                    } else {
                        return String(b[key].label).localeCompare(String(a[key].label))
                    }
                }
            })
        }
        setFilteredList(result)
    }

    const getBackgroundColor = (val, isShow) => {
        let color = "none"
        let floatVal = parseFloat(val)

        if (!isShow) return color

        if (val !== "") {

            let info = find(ratingColorList, (o) => {
                let ok = true
                if (o.condition) {
                    if (typeof o.condition.min !== 'undefined') ok = floatVal >= o.condition.min
                    if (ok && typeof o.condition.max !== 'undefined') ok = floatVal <= o.condition.max
                }
                return ok
            })

            return info?.color?.background ?? "none"


            if (site === "kline") {
                if (floatVal > 0.99 && floatVal <= 1.99) {
                    color = "#FB7454"
                } else if (floatVal > 1.99 && floatVal <= 2.99) {
                    color = "#FDB379"
                } else if (floatVal > 2.99 && floatVal <= 3.99) {
                    color = "#FFE884"
                } else if (floatVal > 3.99 && floatVal <= 4.99) {
                    color = "#D7DF81"
                } else if (floatVal > 4.99) {
                    color = "#77C47C"
                } else if (floatVal >= 0 && floatVal <= 0.99) {
                    color = "#D34B4E"
                }
            } else {
                if (floatVal >= 0 && floatVal <= 0.99) {
                    color = "#320107"
                } else if (floatVal > 0.99 && floatVal <= 1.99) {
                    color = "#67000D"
                } else if (floatVal > 1.99 && floatVal <= 2.99) {
                    color = "#960B13"
                } else if (floatVal > 2.99 && floatVal <= 3.99) {
                    color = "#D34B4E"
                } else if (floatVal > 3.99 && floatVal <= 4.99) {
                    color = "#FB7454"
                } else if (floatVal > 4.99 && floatVal <= 5.99) {
                    color = "#FDB379"
                } else if (floatVal > 5.99 && floatVal <= 6.99) {
                    color = "#FFE884"
                } else if (floatVal > 6.99 && floatVal <= 7.99) {
                    color = "#D7DF81"
                } else if (floatVal > 7.99 && floatVal <= 8.99) {
                    color = "#B7D67F"
                } else if (floatVal > 8.99 && floatVal <= 9.99) {
                    color = "#77C47C"
                } else if (floatVal > 9.99) {
                    color = "#57975C"
                }
            }
        }
        return isShow ? color : "none"
    }

    const getColumnName = (val) => {
        let lang = i18n.language
        let result = val
        if (val?.toLowerCase() === "competency") {
            result = lang === "en-US" ? val : "สมรรถนะ"
        } else if (val?.toLowerCase() === "total emp.") {
            result = lang === "en-US" ? val : "ทั้งหมด"
        } else if (val?.toLowerCase() === "emp. with gap") {
            result = lang === "en-US" ? val : "คนที่ติดลบ"
        } else if (val?.toLowerCase() === "total gap") {
            result = lang === "en-US" ? val : "ช่องว่างทั้งหมด"
        } else if (val?.toLowerCase() === "avg. gap") {
            result = lang === "en-US" ? val : "ช่องว่างเฉลี่ย"
        } else if (val?.toLowerCase() === "avg. rating") {
            result = lang === "en-US" ? val : "คะแนนเฉลี่ย"
        }
        return result
    }


    const getCustomizeColor = (type, value, isShow) => {
        let color = { font: 'none', background: 'none' }
        value = parseFloat(value)

        if (!isShow) return color

        if (customizeData[type] && customizeData[type]?.length) {
            for (const formula of customizeData[type]) {
                if (formula?.condition && formula?.condition?.length) {
                    let ok = true
                    for (const condition of formula?.condition) {
                        if (ok && condition?.symbol) {
                            let condition_value = parseFloat(condition.value)

                            switch (condition?.symbol) {
                                case 'gt': ok = value > condition_value; break;
                                case 'gte': ok = value >= condition_value; break;
                                case 'lt': ok = value < condition_value; break;
                                case 'lte': ok = value <= condition_value; break;
                                case 'eq': ok = value === condition_value; break;
                            }
                        } else {
                            if (typeof condition?.min !== 'undefined' && ok) ok = value >= condition.min
                            else if (typeof condition?.max !== 'undefined' && ok) ok = value <= condition.max
                            else ok = false
                        }
                    }
                    if (ok) color = formula.color
                }

            }

        }
        //console.log('getCustomizeColor', type, value, isShow, customizeData[type], color)

        return color
    }

    const competencyColumnData = useMemo(() => {
        return filteredList?.[0]
    }, [filteredList])

    const valueData = useMemo(() => {
        return filteredList.filter((_, index) => index > 0)
    }, [filteredList])

    // useEffect
    useEffect(() => {
        let query = []
        if (managerDashboardState?.filtersChecked && managerDashboardState?.cycleData?.serial && managerDashboardState?.cycleData?.serial !== "") {
            let reqData = {
                organization_id: [],
                cycle_id: ""
            }
            let orgIds = managerDashboardState?.filtersChecked?.map(filter => {
                return `${filter}`
            })
            if (orgIds.length > 0) {
                reqData.organization_id = orgIds
                reqData.cycle_id = managerDashboardState.cycleData.serial
                setCurrentCycle(managerDashboardState.cycleData)
                setFiltersQuery({ query, reqData })
            }
        }
    }, [managerDashboardState.filtersChecked])

    useEffect(() => {
        if (filtersQuery?.reqData?.cycle_id !== "" && filtersQuery?.reqData?.organization_id?.length > 0) loadData()
    }, [filtersQuery, tableType])

    useEffect(() => {
        let resultList = JSON.parse(JSON.stringify(list))
        let searchList = []
        let excludeList = resultList.filter(
            (_, index) => index <= offsetIndex
        )
        let mergedList = resultList
        if (search !== "") {
            searchList = resultList.filter(
                (item, index) => index > offsetIndex && item?.label?.fullname?.toLowerCase().includes(search.toLowerCase())
            )
            mergedList = [...excludeList, ...searchList]
        }
        // filter by competency type checkbox
        mergedList.forEach((mList, mIndex) => {
            mList.value = mList?.value?.filter((_, valIndex) => excludeFiltersIndex.includes(valIndex))
            mergedList[mIndex].value = mList?.value
        })
        setFilteredList(mergedList)

        let tmpCompetencyLength = []
        if (mergedList?.[0]?.value?.length) {
            for (let i = 0; i < mergedList[0].value.length; i++) {
                tmpCompetencyLength.push(0)
            }
        }
        setTotalCompetency(tmpCompetencyLength)
    }, [search, tableType, offsetIndex, list, excludeFiltersIndex])

    useEffect(() => {
        let tmpList = JSON.parse(JSON.stringify(masterList))
        let excludeCompetencyIndex = []
        tmpList?.[0]?.value?.forEach((list, index) => {
            if (filtersCheckbox.includes(list?.competency_type?.name)) {
                excludeCompetencyIndex.push(index)
            }
        })
        setExcludeFiltersIndex(excludeCompetencyIndex)
    }, [filtersCheckbox, masterList])

    useEffect(() => {
    }, [currentCycle])

    useEffect(() => {
        setFilteredList(list)
    }, [list])

    useEffect(() => {
        if (site === 'kline') {
            setRatingColorList(
                [
                    { "condition": { "min": 0, "max": 0.99 }, "color": { "background": "#FB7454" } }
                    , { "condition": { "min": 1, "max": 1.99 }, "color": { "background": "#FDB379" } }
                    , { "condition": { "min": 2, "max": 2.99 }, "color": { "background": "#FFE884" } }
                    , { "condition": { "min": 3, "max": 3.99 }, "color": { "background": "#D7DF81" } }
                    , { "condition": { "min": 4, "max": 4.99 }, "color": { "background": "#77C47C" } }
                    , { "condition": { "min": 5 }, "color": { "background": "#D34B4E" } }
                ]
            )
        }
    }, [site])

    useEffect(() => {
        if (customizeData?.rating) {
            let list_data = []

            for (const info of customizeData.rating) {
                console.log(info.condition, isArray(info.condition))
                list_data.push({ "condition": isArray(info.condition) ? info.condition[0] : info.condition, "color": info.color })
            }

            setRatingColorList(list_data)
        }
    }, [customizeData])

    // end useEffect

    return (
        <>
            <Box id="back-to-top-anchor"> </Box>
            <Grid container>
                <Grid item xs>
                    <ToggleButtonGroup
                        color="primary"
                        value={tableType}
                        exclusive
                        onChange={handleChangeTableType}
                        aria-label="Evaluation Data Table"
                    >
                        <ToggleButton value="gap" sx={{ width: "177px", height: "45px", backgroundColor: "#FFF", textTransform: "none", borderRadius: "5px 0px 0px 0px" }} classes={{ selected: classes.toggleBtnSelected }}>
                            <Typography fontSize="16px" fontWeight={tableType === "gap" ? "500" : "400"} color={tableType === "gap" ? "#FFF" : "#AAAAAA"}>{t("dashboardManager.label.competencyGap")}</Typography>
                        </ToggleButton>
                        <ToggleButton value="rating" sx={{ width: "177px", height: "45px", backgroundColor: "#FFF", textTransform: "none", borderRadius: "0px 5px 0px 0px" }} classes={{ selected: classes.toggleBtnSelected }}>
                            <Typography fontSize="16px" fontWeight={tableType === "rating" ? "500" : "400"} color={tableType === "rating" ? "#FFF" : "#AAAAAA"}>{t("dashboardManager.label.competencyRating")}</Typography>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs>
                    <Box className={classes.paperRoot}>
                        <Paper className={classes.flexPaper}>
                            <Grid container mb={4}>
                                <Grid item>
                                    <Typography fontSize={24} fontWeight="600">{tableType === "gap" ? t("dashboardManager.label.competencyGap") : t("dashboardManager.label.competencyRating")}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container mb={2} columnSpacing="30px">
                                <Grid item>
                                    <TextField
                                        id="search-table"
                                        fullWidth
                                        placeholder={tableType === "gap" ? t("dashboardManager.label.searchPlaceholderCompetency1") : t("dashboardManager.label.searchPlaceholderCompetency2")}
                                        size="small"
                                        sx={{
                                            background: "#fff",
                                            width: "400px",
                                            height: "45px",
                                            input: {
                                                width: "100%",
                                                height: "28px",
                                            }
                                        }}
                                        value={search}
                                        onChange={handleSearch}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search style={{ color: "#C4C4C4" }} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Button
                                        size="small"
                                        aria-controls="filters-menu"
                                        aria-haspopup="true"
                                        onClick={handleClickFilters}
                                        color="black"
                                        variant="outlined"
                                        sx={{
                                            marginRight: '15px',
                                            textTransform: "none",
                                            height: "45px",
                                            minWidth: "103px"
                                        }}
                                    >
                                        <FilterIcon style={{ width: '20px', height: '20px' }} />
                                        <Typography ml={1} fontWeight="600" fontSize="16px">{t("dashboardManager.label.filters")}</Typography>
                                    </Button>
                                    <Popover
                                        id={idFilters}
                                        open={openFilters}
                                        anchorEl={filterAnchor}
                                        onClose={handleCloseFilters}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                    >
                                        {filtersCheckboxList ?
                                            (<Box
                                                sx={{
                                                    p: 2,
                                                }}>
                                                <Typography fontSize="16px" fontWeight="600" sx={{ my: 1 }}>
                                                    {t("dashboardManager.label.competencyTypes")}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        flexDirection: "column",
                                                        pl: "4px",
                                                        pr: "4px"
                                                    }}>
                                                    <FormControlLabel
                                                        style={{ fontSize: '14px' }}
                                                        label={t("label.selectAll")}
                                                        control={
                                                            <CustomCheckbox
                                                                checked={filtersCheckbox.length === filtersCheckboxList.length}
                                                                indeterminate={filtersCheckbox.length > 0 && filtersCheckbox.length < filtersCheckboxList.length}
                                                                onChange={() => handleFiltersCheckbox("all")}
                                                            />
                                                        }
                                                    />
                                                    {
                                                        filtersCheckboxList.map((item) => {
                                                            return (
                                                                <FormControlLabel
                                                                    style={{ fontSize: '14px' }}
                                                                    label={item}
                                                                    key={item}
                                                                    control={<CustomCheckbox color="primary" checked={filtersCheckbox.includes(item)} onChange={() => handleFiltersCheckbox(item)} />}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </Box>
                                            </Box>) : null
                                        }
                                    </Popover>
                                </Grid>
                            </Grid>
                            {
                                competencyColumnData?.value?.length > 0 ?
                                    <>
                                        <Box sx={{ display: "flex" }}>
                                            {/* Competency Label column */}
                                            <Box sx={{
                                                m: "19px 0 19px 25px",
                                                maxHeight: tableType === "gap" ? "1121px" : "1024px",
                                                position: "relative",
                                                width: "400px",
                                                overflow: "scroll",
                                                flex: "1 0 auto",
                                                "-ms-overflow-style": "none",
                                                scrollbarWidth: "none",
                                                "&::-webkit-scrollbar": {
                                                    width: "0 !important",
                                                    height: "0 !important"
                                                }
                                            }}
                                                id="scrollable-name"
                                                onScroll={() => SyncScroll("scrollable-name")}
                                            >
                                                {
                                                    competencyColumnData && (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                width: "450px",
                                                                py: "12px",
                                                                background: "#FFF",
                                                                position: "sticky",
                                                                top: 0,
                                                                borderBottom: "1px solid #E5E5E5"
                                                            }}
                                                        >

                                                            <Typography
                                                                fontSize={16}
                                                                lineHeight="23.96px"
                                                                color="#A0A0A0"
                                                                fontWeight="500"
                                                                sx={{
                                                                    whiteSpace: "nowrap",
                                                                    width: "100%",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    maxWidth: "max-content",
                                                                    mr: "10px",
                                                                }}
                                                            >
                                                                {getColumnName(competencyColumnData.label?.name) ?? "-"}
                                                            </Typography>
                                                        </Box>
                                                    )
                                                }
                                                {
                                                    competencyColumnData?.value &&
                                                    competencyColumnData?.value?.map((row, index) => {
                                                        return (
                                                            <>
                                                                <Box key={`emp-${index}`} sx={{ display: "flex", flexDirection: "column", width: "400px" }}>
                                                                    <Box
                                                                        sx={{
                                                                            height: "96px",
                                                                            background: "#FFF",
                                                                            width: "100%",
                                                                            display: "flex",
                                                                            alignItems: "center"
                                                                        }}
                                                                    >
                                                                        <Box sx={{ width: "100%" }}>
                                                                            <Grid container spacing={2} flexWrap="nowrap" display="flex" alignItems="center">
                                                                                <Grid item display="flex" alignItems="center">
                                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "40px", height: "40px", background: `${row?.competency_type?.color}`, borderRadius: "5px" }}>
                                                                                        <BootstrapTooltip
                                                                                            placement="top"
                                                                                            arrow
                                                                                            title={row?.competency_type?.name ?? "-"}
                                                                                        >
                                                                                            <Icon sx={{ color: "#FFF", fontSize: "20px" }}>{row?.competency_type?.icon}</Icon>
                                                                                        </BootstrapTooltip>
                                                                                    </Box>
                                                                                </Grid>
                                                                                <Grid item xs={12} display="flex" alignItems="center" flexDirection="column">
                                                                                    <Grid container>
                                                                                        <Grid item xs={12} display="flex" alignItems="center" pr={1}>
                                                                                            <BootstrapTooltip
                                                                                                placement="top"
                                                                                                arrow
                                                                                                title={row?.name ?? "-"}
                                                                                                style={{ ml: 0 }}>
                                                                                                <Typography fontSize="18px" fontWeight="500" sx={{ textOverflow: "ellipsis", overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 1, WebkitBoxOrient: "vertical", maxWidth: "40ch" }}>
                                                                                                    {row?.name ?? "-"}
                                                                                                </Typography>
                                                                                            </BootstrapTooltip>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    {
                                                                                        row?.proficiency_level && row?.proficiency_level !== "" &&
                                                                                        <Grid container>
                                                                                            <Grid item display="flex" alignItems="center">
                                                                                                <Typography fontSize="14px" fontWeight="400" color="#AAAAAA">
                                                                                                    {t("dashboardManager.label.level")} {row?.proficiency_level}
                                                                                                </Typography>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    }
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                                <Divider />
                                                            </>
                                                        )
                                                    })
                                                }
                                                {tableType === "gap" &&
                                                    <Box
                                                        sx={{
                                                            height: "102px",
                                                            background: "#FFF",
                                                            width: "100%",
                                                            position: "sticky",
                                                            bottom: 0
                                                        }}
                                                    >
                                                    </Box>
                                                }
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "column", overflow: "auto", maxHeight: tableType === "gap" ? "1121px" : "1030px", mt: "19px" }} className="dashboard-competency" onScroll={() => SyncScroll("scrollable-data")} id="scrollable-data">
                                                <Box
                                                    pr="25px"
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                    }}
                                                >
                                                    {
                                                        tableType === "gap" ?
                                                            <>
                                                                {
                                                                    valueData && valueData.map((row, rowIndex) => {
                                                                        return (
                                                                            <Box
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    flexDirection: "column",
                                                                                    width: "150px",
                                                                                    position: "relative",
                                                                                }}
                                                                                key={`value-${rowIndex}`}
                                                                            >
                                                                                <Box
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        flexDirection: "row",
                                                                                        width: "150px",
                                                                                        py: "12px",
                                                                                        borderBottom: "1px solid #E5E5E5",
                                                                                        flex: "0 0 auto",
                                                                                        justifyContent: "center",
                                                                                        backgroundColor: rowIndex >= offsetIndex ? "#F3F3F3" : "#FFF",
                                                                                        position: "sticky",
                                                                                        top: 0
                                                                                    }}
                                                                                >
                                                                                    <BootstrapTooltip
                                                                                        placement="top"
                                                                                        arrow
                                                                                        title={rowIndex >= offsetIndex ? `${row?.label?.fullname} (${row?.label?.position}, ${row?.label?.organization})` : getColumnName(row?.label?.name) ?? "-"}
                                                                                        style={{ marginLeft: '5px' }}>
                                                                                        <Typography
                                                                                            fontSize={16}
                                                                                            lineHeight="23.96px"
                                                                                            color="#A0A0A0"
                                                                                            fontWeight="500"
                                                                                            sx={{
                                                                                                whiteSpace: "nowrap",
                                                                                                width: "100%",
                                                                                                overflow: "hidden",
                                                                                                textOverflow: "ellipsis",
                                                                                                maxWidth: "max-content",
                                                                                                mr: "10px",
                                                                                            }}
                                                                                        >
                                                                                            {getColumnName(row?.label?.name) ?? "-"}
                                                                                        </Typography>
                                                                                    </BootstrapTooltip>
                                                                                </Box>
                                                                                {
                                                                                    totalCompetency.map((_, index) => {
                                                                                        let value = row?.value?.[index]?.value ? row?.value?.[index]?.value : row?.value?.[index]
                                                                                        let font_color = rowIndex >= offsetIndex ? row?.value?.[index]?.value >= 0 ? "#5DA196" : "#CC6058" : "#404349"
                                                                                        let background_color = rowIndex >= offsetIndex ? row?.value?.[index]?.value ? row?.value?.[index]?.value >= 0 ? "#eef5f4" : "#faefee" : "none" : "none"

                                                                                        let customize_color = getCustomizeColor('gap', value, rowIndex >= offsetIndex ? true : false)
                                                                                        if (customize_color?.font !== 'none') font_color = customize_color.font
                                                                                        if (customize_color?.background !== 'none') background_color = customize_color.background

                                                                                        return (
                                                                                            <>
                                                                                                <Box
                                                                                                    sx={{
                                                                                                        height: "96px",
                                                                                                        background: "#FFF",
                                                                                                        width: "100%",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center",
                                                                                                        wordBreak: "break-all",
                                                                                                        justifyContent: "center",
                                                                                                        backgroundColor: background_color,
                                                                                                    }}
                                                                                                    key={`total-${index}`}
                                                                                                >
                                                                                                    <Typography fontSize={rowIndex >= offsetIndex ? "20px" : "16px"} fontWeight={rowIndex >= offsetIndex ? "600" : "500"} color={font_color}>{value}</Typography>
                                                                                                </Box>
                                                                                                <Divider />
                                                                                            </>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Box>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                {
                                                                    valueData && valueData.map((row, rowIndex) => {
                                                                        return (
                                                                            <Box
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    flexDirection: "column",
                                                                                    position: "relative"
                                                                                }}
                                                                                key={`value-${rowIndex}`}
                                                                            >
                                                                                <Box
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        flexDirection: "row",
                                                                                        width: "150px",
                                                                                        py: "12px",
                                                                                        borderBottom: "1px solid #E5E5E5",
                                                                                        flex: "0 0 auto",
                                                                                        justifyContent: "center",
                                                                                        backgroundColor: rowIndex >= offsetIndex ? "#F3F3F3" : "#FFF",
                                                                                        position: "sticky",
                                                                                        top: 0
                                                                                    }}
                                                                                >
                                                                                    <BootstrapTooltip
                                                                                        placement="top"
                                                                                        arrow
                                                                                        title={rowIndex >= offsetIndex ? `${row?.label?.fullname} (${row?.label?.position}, ${row?.label?.organization})` : getColumnName(row?.label?.name) ?? "-"}
                                                                                        style={{ marginLeft: '5px' }}>
                                                                                        <Typography
                                                                                            fontSize={16}
                                                                                            lineHeight="23.96px"
                                                                                            color="#A0A0A0"
                                                                                            fontWeight="500"
                                                                                            sx={{
                                                                                                whiteSpace: "nowrap",
                                                                                                width: "100%",
                                                                                                overflow: "hidden",
                                                                                                textOverflow: "ellipsis",
                                                                                                maxWidth: "max-content",
                                                                                                mr: "10px",
                                                                                            }}
                                                                                        >
                                                                                            {getColumnName(row?.label?.name) ?? "-"}
                                                                                        </Typography>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        style={{
                                                                                            flexDirection: "column",
                                                                                            justifyContent: "center",
                                                                                            display: "flex",
                                                                                        }}
                                                                                    >
                                                                                    </Typography>
                                                                                </Box>
                                                                                {
                                                                                    totalCompetency.map((_, index) => {
                                                                                        let value = row?.value?.[index]?.value ? row?.value?.[index]?.value : row?.value?.[index]
                                                                                        let font_color = '#404349'
                                                                                        let background_color = getBackgroundColor(value, rowIndex >= offsetIndex ? true : false)

                                                                                        let customize_color = getCustomizeColor('rating', value, rowIndex >= offsetIndex ? true : false)
                                                                                        if (customize_color?.font !== 'none') font_color = customize_color.font
                                                                                        if (customize_color?.background !== 'none') background_color = customize_color.background


                                                                                        return (
                                                                                            <>
                                                                                                <Box
                                                                                                    sx={{
                                                                                                        height: "96px",
                                                                                                        background: "#FFF",
                                                                                                        width: "100%",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center",
                                                                                                        background: background_color,
                                                                                                        justifyContent: "center",
                                                                                                        wordBreak: "break-all"
                                                                                                    }}
                                                                                                    key={`total-${index}`}
                                                                                                >
                                                                                                    <Typography fontSize={rowIndex >= offsetIndex ? "20px" : "16px"} fontWeight={rowIndex >= offsetIndex ? "600" : "500"} color={font_color} sx={{ textShadow: rowIndex >= offsetIndex ? "0 0 2px white, 0 0 2px white, 0 0 2px white, 0 0 2px white" : "none" }}>{row?.value?.[index]?.value ? row?.value?.[index]?.value : row?.value?.[index]}
                                                                                                    </Typography>
                                                                                                </Box>
                                                                                                <Divider />
                                                                                            </>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Box>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                    }
                                                </Box>
                                                {
                                                    tableType === "gap" &&
                                                    <Box sx={{
                                                        display: "flex", flexDirection: "row", position: "sticky",
                                                        bottom: 0
                                                    }}>
                                                        <Box sx={{ background: "#FFF", pl: `calc(150px * ${offsetIndex - 1})` }}></Box>
                                                        <Box
                                                            sx={{
                                                                height: "96px",
                                                                background: "#FFF",
                                                                width: "150px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                flex: "0 0 auto",
                                                            }}
                                                        >
                                                            <Typography fontSize="18px" fontWeight="500" color="#A0A0A0">{t("dashboardManager.label.totalGap")}</Typography>
                                                        </Box>
                                                        {
                                                            valueData && valueData.map((row, rowIndex) => {
                                                                if (rowIndex >= offsetIndex) {
                                                                    let font_color = row?.sumTotalGap >= 0 ? "#5DA196" : "#CC6058"
                                                                    let background_color = row?.sumTotalGap >= 0 ? "#eef5f4" : "#faefee"

                                                                    let customize_color = getCustomizeColor('gap', row?.sumTotalGap, true)
                                                                    if (customize_color?.font !== 'none') font_color = customize_color.font
                                                                    if (customize_color?.background !== 'none') background_color = customize_color.background

                                                                    return (
                                                                        <Box
                                                                            sx={{
                                                                                height: "96px",
                                                                                background: "#FFF",
                                                                                width: "150px",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                flex: "0 0 auto",
                                                                                background: background_color,
                                                                                alignItems: "center",
                                                                                justifyContent: "center"
                                                                            }}
                                                                            key={`value-gap-${rowIndex}`}
                                                                        >
                                                                            <Typography fontSize="20px" fontWeight="600" color={font_color}>{row?.sumTotalGap}</Typography>
                                                                        </Box>)
                                                                }
                                                            })
                                                        }
                                                    </Box>
                                                }
                                            </Box>
                                        </Box>
                                        {
                                            tableType === "rating" &&
                                            <Box sx={{ mt: 2 }}>
                                                <Box>
                                                    <Typography fontSize="16px" fontWeight="500">{t("dashboardManager.label.colorDescription")}</Typography>
                                                </Box>

                                                <Box sx={{ display: "flex", mt: 2 }}>
                                                    {ratingColorList.map((info, i) => {
                                                        let label = ''
                                                        if (typeof info?.condition?.min !== 'undefined' && typeof info?.condition?.max !== 'undefined') {
                                                            label = '= ' + info?.condition?.min.toFixed(2) + ' - ' + info?.condition?.max.toFixed(2)
                                                        } else if (typeof info?.condition?.min !== 'undefined') {
                                                            label = '>= ' + info?.condition?.min.toFixed(2)
                                                        } else if (typeof info?.condition?.max !== 'undefined') {
                                                            label = '<= ' + info?.condition?.max.toFixed(2)
                                                        }
                                                        return (
                                                            <Box key={i} sx={{ display: "flex", mr: 2 }}>
                                                                <Box sx={{ width: "25px", height: "25px", borderRadius: "3px", mr: "5px", background: info.color.background }} />
                                                                <Typography>{label}</Typography>
                                                            </Box>
                                                        )
                                                    })}
                                                </Box>


                                            </Box>
                                        }
                                    </>
                                    : <NoData />
                            }
                        </Paper>
                    </Box>
                </Grid>
            </Grid >
            {Util.ScrollToTop()}
        </>
    )
}
export default CompetencyManagerDashboard
